import { faker } from '@faker-js/faker';
import { Factory, trait } from 'miragejs';

export default Factory.extend({
  convertRunning() {
    return false;
  },

  convertMessage() {
    return 'OK';
  },

  convertCommandLog() {
    return 'Log Message';
  },

  cropDimension() {
    return '300|100';
  },

  cropXy() {
    return '0|0';
  },

  dateStart() {
    return faker.date.past();
  },

  dateEnd() {
    return faker.date.past();
  },

  source: trait({
    afterCreate(assetFormatRelation, server) {
      assetFormatRelation.update({
        assetFormat: server.create('asset-format', 'source'),
      });
    },
  }),

  formatVideo: trait({
    afterCreate(assetFormatRelation, server) {
      assetFormatRelation.update({
        assetFormat: server.create('asset-format', 'format836'),
      });
    },
  }),
});

// @attr('string') assetTypeSelector;
// @attr('string') audioBitrate;
// @attr('string') audioChannels;
// @attr('string') audioCodec;
// @attr('string') audioFrequenz;
// @attr('boolean') convertRunning;
// @attr('string') convertMessage;
// @attr('string') convertCommandLog
// @attr('string') cropDimension;
// @attr('string') cropXy;
// @attr('string') duration;
// @attr dateEnd;
// @attr dateStart;
// @attr('string') fileSize;
// @attr('string') flagManualRedo;
// @attr('string') flagRedo;
// @attr('number') height;
// @attr('boolean') isManualUpload;
// @attr('string') mimeType;
// @attr('number', { defaultValue: 0 }) priority;
// @attr('string') tmpAssetName;
// @attr('string') videoBitrate;
// @attr('string') videoCodec;
// @attr('number') width;

// // CMS fields
// @attr('number', { defaultValue: 2 }) cmsState;

// // Meta fields
// @attr cmsCreated;
// @attr cmsDeleted;
// @attr cmsModified;
// @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
// @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
// @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

// // Relations
// @belongsTo('asset-format', { async: true, inverse: null }) assetFormat;
// @belongsTo('asset', { async: true, inverse: 'assetFormatRelations' }) asset;
